import { getStyledHeader } from '@Components/Text/Header/styled';
import { HeaderProps } from '@Components/Text/Header/types';

function Header({
	variant = 'h1',
	weight = 'bold',
	text,
	children,
	ref,
	...rest
}: HeaderProps) {
	const content = text || children;
	const Header = getStyledHeader(variant);
	return (
		<Header weight={weight} ref={ref} {...rest}>
			{content}
		</Header>
	);
}

export default Header;
